import { resolveAssetPath } from "../../shared/utilities/assets";
import type { WeddingData } from "../../types/wedding";

interface Props {
  barcode: WeddingData["barcode"];
  open: boolean;
  closeLabel: string;
  onClose: () => void;
}

export function BarcodeModal({ barcode, open, closeLabel, onClose }: Props) {
  if (!open || !barcode.enabled || !barcode.image) return null;
  return (
    <div className="barcode-modal is-visible" role="dialog" aria-modal="true" aria-labelledby="barcode-title">
      <div className="barcode-page">
        <button type="button" className="close-lightbox" onClick={onClose}>{closeLabel}</button>
        <p className="eyebrow">Invitation Barcode</p>
        <h2 id="barcode-title">{barcode.title}</h2>
        <p>{barcode.description}</p>
        <img src={resolveAssetPath(barcode.image)} alt={barcode.title} />
      </div>
    </div>
  );
}
